import { render, staticRenderFns } from "./viewVideo.vue?vue&type=template&id=7cfc6a4c&scoped=true"
import script from "./viewVideo.vue?vue&type=script&lang=js"
export * from "./viewVideo.vue?vue&type=script&lang=js"
import style0 from "./viewVideo.vue?vue&type=style&index=0&id=7cfc6a4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfc6a4c",
  null
  
)

export default component.exports